import { ContentBlock, ContentState, DraftDecorator } from 'draft-js';
import { DraftDecoratorComponentProps, RichEditorVariable, TriggerRange } from '../types';
import { findWithRegex, getVariableRegex } from '../utils';
import React from 'react';

export const getVariableSelectionDecorator = ({
    variables,
    ref,
    triggerRange,
    token = '$',
}: {
    variables: RichEditorVariable[];
    ref: (ref: HTMLSpanElement) => void;
    triggerRange?: TriggerRange;
    token?: string;
}): DraftDecorator => {
    return {
        strategy: createVariableSelectionStrategy(variables, token),
        component: VariableSelectionPortal,
        props: { ref, triggerRange },
    };
};

const createVariableSelectionStrategy = (variables: RichEditorVariable[], token: string = '$') => {
    return (contentBlock: ContentBlock, callback: (start: number, end: number) => void, _: ContentState) => {
        const VARIABLE_REGEX = getVariableRegex(token);
        findWithRegex(VARIABLE_REGEX, contentBlock, callback, (value) => {
            const compareVar = value.substring(1).toLowerCase();
            for (const variable of variables) {
                if (`${token}${variable.displayText}`.toLowerCase().indexOf(compareVar) > -1) {
                    return `${token}${variable.name}`.toLowerCase() !== compareVar;
                }
            }
            return false;
        });
    };
};

const VariableSelectionPortal = React.forwardRef<
    HTMLSpanElement,
    { triggerRange?: TriggerRange } & DraftDecoratorComponentProps
>((props, ref) => {
    const { children, triggerRange, blockKey, start, end } = props;
    let isCurrentRef = true;

    if (triggerRange) {
        isCurrentRef = triggerRange.blockKey === blockKey && triggerRange.start === start && triggerRange.end === end;
    }

    return <span ref={isCurrentRef ? ref : undefined}>{children}</span>;
});
VariableSelectionPortal.displayName = 'VariableSelectionPortal';
